import { useEffect, useState } from 'react'

import { OperatorData, useOperator } from '../'
import { authHeader } from '../../api/'
import { refreshToken } from '../auth/'

const { REACT_APP_API_URL, REACT_APP_VER_HISTORY_AGGREGATED } = import.meta.env

export const useMissingData = id => {
  const [data, setData] = useState(null)
  const [isError, setError] = useState(null)
  const [isLoading, setLoading] = useState(true)

  const opData: OperatorData = useOperator()

  useEffect(() => {
    if (Number(id) <= 0 || !opData?.isAdmin) return

    const load = async () => {
      setLoading(true)
      setError(null)

      try {
        await refreshToken()
        const url = `${REACT_APP_API_URL}/missingdata/admin/missingdata/${id}?${REACT_APP_VER_HISTORY_AGGREGATED}`
        const options = { headers: { ...authHeader() }, method: 'GET' }
        const response = await fetch(url, options)
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const item = await response.json()
        setData(item)
      } catch (error) {
        setError(error?.message || 'Fehler beim Laden')
      } finally {
        setLoading(false)
      }
    }

    load()
  }, [id, opData?.isAdmin])

  return { isLoading, isError, data, setData }
}
